import Api from "~/service/Api";

class CustomerStatisticRepository {
  fetchOne(customerId, query) {
    return Api.get(`/customer/statistics/${customerId}`, query);
  }
}

export default CustomerStatisticRepository;
